import domains from '../../data/sampleEmailDomains.json';
export const WORK_EMAIL_MESSAGE = 'Please use your company or organization email. Personal and temporary email services are not accepted.';
export const workEmailError = email => {
  const value = email.trim();
  if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return 'Enter a valid work email address.';
  const domain = value.split('@')[1].toLowerCase();
  return domains.some(blocked => domain === blocked || domain.endsWith(`.${blocked}`)) ? WORK_EMAIL_MESSAGE : '';
};
